export default __webpack_public_path__ + "static/media/ReminderSlack.be1bb89a.png";